import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { PAYMENT_CYCLES, SERVICE_TYPES } from 'common/Constants';
import { formatMoney } from 'common/Utils';

export default function data({ model, deleteEvent, editEvent }) {
  model = model ?? [];

  const Overall = ({ name, id, type }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <div>
        <button code={"btnEdit" + id} onClick={() => editEvent(`${id}`)}
          style={{ border: 0, backgroundColor: 'transparent' }}>
          <MDBadge
            badgeContent="Sửa"
            color="success"
            variant="gradient"
            size="sm"
          />
        </button>
        <div style={{ height: 4 }} />
        <button
          style={{ border: 0, backgroundColor: 'transparent' }}
          code={"btnDelete" + id}
          onClick={() => {
            deleteEvent(`${id}`);
          }}
        >
          <MDBadge
            badgeContent="Xóa"
            color="warning"
            variant="gradient"
            size="sm"
          />
        </button>
      </div>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{id}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const ItemCell = ({ value }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography variant="caption">{value}</MDTypography>
    </MDBox>
  );

  const rows = [];

  model.forEach((item) => {
    rows.push({
      overall: <Overall name={item.name} id={item.id ?? 0} type={item.type} />,
      price: <ItemCell value={formatMoney(item.price)} />,
      paymentCycle: <ItemCell value={PAYMENT_CYCLES.find(o => o.id === item.paymentCycle)?.name ?? ''} />,
      description: <ItemCell value={item.description} />,
    });
  });

  return {
    columns: [
      { Header: "Mục", accessor: "overall", width: "30%", align: "left" },
      { Header: "Đơn giá (VNĐ)", accessor: "price", width: "20%", align: "left" },
      { Header: "Chu kỳ thanh toán", accessor: "paymentCycle", width: "20%", align: "left" },
      { Header: "Mô tả", accessor: "description", align: "left" },
    ],
    rows: rows,
  };
}
